import type { SupStoredTxSettings } from "@/types";
import React, { type Dispatch, type SetStateAction } from "react";

import Web3TxSettingsGroupRefundAddress from "@/components/Web3/TxSettings/Group/RefundAddress";
import { SupScrollable, SupTabPanel, SupText } from "@repo/core-ui";
import Link from "next/link";

interface Web3TxSettingsTabRefundsProps {
  settings: SupStoredTxSettings;
  setSettings: Dispatch<SetStateAction<SupStoredTxSettings>>;
}

export default function Web3TxSettingsTabRefunds({ settings, setSettings }: Web3TxSettingsTabRefundsProps) {
  return (
    <SupTabPanel className="flex flex-col space-y-6 py-4" unmountOnExit value="refunds">
      <SupScrollable className="scrollbar-custom max-h-[calc(90vh-250px)]" orientation="vertical" contentClassName="space-y-6">
        <SupText as="div" variant="subtitle1" className="space-y-4">
          <p>
            IF YOU’RE ACCESSING SUPERFORM FROM A SMART CONTRACT WALLET OR A MULTI-SIG WHERE YOU DON’T CONTROL THE SOURCE CHAIN ADDRESS ON THE DESTINATION CHAIN(S) PLEASE SPECIFY A
            REFUND ADDRESS THAT YOU CONTROL ON THE DESTINATION CHAIN(S)
          </p>
          <p>IF THE TRANSACTION FAILS ON THE DESTINATION CHAIN(S), WE WILL SEND YOUR TOKENS TO YOUR SPECIFIED REFUND ADDRESS.</p>
          <Link
            className="inline-flex underline underline-offset-2 hover:text-primary-200 hover:no-underline"
            href="https://help.superform.xyz/en/articles/10224069-what-is-the-refund-address"
            target="_blank"
          >
            Learn more
          </Link>
        </SupText>
        <div className="flex w-full flex-col border-0.5 border-neutral-600">
          <Web3TxSettingsGroupRefundAddress settings={settings} setSettings={setSettings} />
        </div>
      </SupScrollable>
    </SupTabPanel>
  );
}
